import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/vetdata-Logo.jpg'


const _hoisted_1 = { style: {"height":"32px","width":"127px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createBlock(_component_v_list, {
    nav: true,
    density: "compact"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list_item, null, _createSlots({
        default: _withCtx(() => [
          _createVNode(_component_v_list_item_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: { name: 'Home' } }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (!_ctx.isMiniVariant)
                      ? (_openBlock(), _createBlock(_component_v_img, {
                          key: 0,
                          src: _imports_0
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 2
      }, [
        (_ctx.$vuetify.display.lgAndUp)
          ? {
              name: "prepend",
              fn: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "mdi-menu",
                  style: {"font-size":"24px","height":"24px","width":"24px"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('mini-variant-changed', !_ctx.isMiniVariant)))
                })
              ]),
              key: "0"
            }
          : undefined
      ]), 1024),
      _createVNode(_component_v_divider, { class: "mb-2" }),
      (_ctx.loggedIn)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.hasAccess('Navigation.Kontobrowser'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 0,
                  link: "",
                  class: "mb-2",
                  "prepend-icon": "mdi-home-account",
                  to: { name: 'Home' },
                  title: _ctx.$t('navigation.tvskonto'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.Lieferantenrechnung'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 1,
                  class: "mb-2",
                  link: "",
                  "prepend-icon": "mdi-format-list-bulleted",
                  to: { name: 'Lieferantenrechnungen' },
                  title: _ctx.$t('navigation.lieferantenrechnung'),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.Praxisgrupperechnungen'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 2,
                  class: "mb-2",
                  link: "",
                  "prepend-icon": "mdi-format-list-bulleted",
                  to: { name: 'PraxisgruppeRechnungen' },
                  title: _ctx.$t('navigation.praxisgruppe.rechnungen'),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.PraxisgruppeTeilnehmerAdministration'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 3,
                  class: "mb-2",
                  link: "",
                  "prepend-icon": "mdi-account-search",
                  to: { name: 'PraxisgruppeTeilnehmerAdministration' },
                  title: _ctx.$t('navigation.praxisgruppe.teilnehmeradministration'),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.PraxisgruppeEinstellungen'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 4,
                  class: "mb-2",
                  link: "",
                  "prepend-icon": "mdi-account-cog",
                  to: { name: 'PraxisgruppeEinstellungen' },
                  title: _ctx.$t('navigation.praxisgruppe.einstellungen'),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.Dokumentarchiv'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 5,
                  link: "",
                  "prepend-icon": "mdi-magnify",
                  to: { name: 'Dokumentarchiv' },
                  title: _ctx.$t('navigation.dokumentarchiv'),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.Dokumentupload'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 6,
                  link: "",
                  "prepend-icon": "mdi-upload",
                  to: { name: 'Dokumentupload' },
                  title: _ctx.$t('navigation.dokumentupload'),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.Benutzereinstellungen'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 7,
                  link: "",
                  "prepend-icon": "mdi-account-cog",
                  to: { name: 'Einstellungen' },
                  title: _ctx.$t('navigation.einstellungen'),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.TeilnehmerAdministration'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 8,
                  link: "",
                  "prepend-icon": "mdi-account-search",
                  to: { name: 'TeilnehmerAdmin' },
                  title: _ctx.$t('navigation.teilnehmeradmin'),
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.BenutzerSuche'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 9,
                  link: "",
                  "prepend-icon": "mdi-account-search",
                  to: { name: 'BenutzerSuche' },
                  title: _ctx.$t('navigation.benutzerSuche'),
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.VetpointDaten'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 10,
                  link: "",
                  "prepend-icon": "mdi-format-list-bulleted",
                  to: { name: 'VetpointDaten' },
                  title: _ctx.$t('vetpointdaten.title'),
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.FehlerhafteRechnungen'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 11,
                  link: "",
                  "prepend-icon": "mdi-file-cancel",
                  to: { name: 'FehlerhafteRechnungen' },
                  title: _ctx.$t('navigation.fehlerhafteRechnungen'),
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.TreuhandTeilnehmerListe'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 12,
                  link: "",
                  "prepend-icon": "mdi-format-list-bulleted",
                  to: { name: 'TreuhandTeilnehmerListe' },
                  title: _ctx.$t('navigation.TreuhandTeilnehmerListe'),
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.TreuhandEinstellungen'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 13,
                  link: "",
                  "prepend-icon": "mdi-account-cog",
                  to: { name: 'TreuhandEinstellungen' },
                  title: _ctx.$t('navigation.TreuhandEinstellungen'),
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.TvsKundenListe'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 14,
                  link: "",
                  "prepend-icon": "mdi-account-search",
                  to: { name: 'TvsKundenListe' },
                  title: _ctx.$t('navigation.TvsKundenListe'),
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.LieferantRechnungen'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 15,
                  link: "",
                  "prepend-icon": "mdi-format-list-bulleted",
                  to: { name: 'LieferantRechnungen' },
                  title: _ctx.$t('navigation.LieferantRechnungen'),
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.LieferantFehlerhafteRechnungen'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 16,
                  link: "",
                  "prepend-icon": "mdi-file-cancel",
                  to: { name: 'LieferantFehlerhafteRechnungen' },
                  title: _ctx.$t('navigation.LieferantFehlerhafteRechnungen'),
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.LieferantRechnungen'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 17,
                  link: "",
                  "prepend-icon": "mdi-form-textbox",
                  to: { name: 'LieferantRechnungFormular' },
                  title: _ctx.$t('navigation.LieferantRechnungFormular'),
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.LieferantDokumentArchiv'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 18,
                  link: "",
                  "prepend-icon": "mdi-file-multiple",
                  to: { name: 'LieferantDokumentArchiv' },
                  title: _ctx.$t('navigation.LieferantDokumentArchiv'),
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.LieferantEinstellungen'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 19,
                  link: "",
                  "prepend-icon": "mdi-account-cog",
                  to: { name: 'LieferantEinstellungen' },
                  title: _ctx.$t('navigation.LieferantEinstellungen'),
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.AdminLieferantDokumentArchiv'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 20,
                  link: "",
                  "prepend-icon": "mdi-file-multiple",
                  to: { name: 'AdminLieferantDokumentArchiv' },
                  title: _ctx.$t('navigation.AdminLieferantDokumentArchiv'),
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.LieferantDokumentUpload'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 21,
                  link: "",
                  "prepend-icon": "mdi-upload",
                  to: { name: 'LieferantenDokumentUpload' },
                  title: _ctx.$t('navigation.lieferantenDokumentUpload'),
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.Konfiguration'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 22,
                  link: "",
                  "prepend-icon": "mdi-cog",
                  to: { name: 'Konfiguration' },
                  title: _ctx.$t('navigation.Konfiguration'),
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.hasAccess('Navigation.TakeTeilnehmer'))
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 23,
                  link: "",
                  "prepend-icon": "mdi-account-convert",
                  to: { name: 'TakeTeilnehmer' },
                  title: _ctx.$t('navigation.TakeTeilnehmer'),
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.setAccessDenied(false)))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}